import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui2-empty-state',
  templateUrl: './ui2-empty-state.component.html',
  styleUrls: ['./ui2-empty-state.component.scss']
})
export class Ui2EmptyStateComponent {
  /**
   * Title for empty state
   */
  @Input() title = '';

  /**
   * Description for empty state
   */
  @Input() text = '';

  /**
   * Image to be shown for empty state
   */
  @Input() imgSrc: string;

  /**
   * Image width
   */
  @Input() imgWidth: string = 'auto';

  /**
   * Image height
   */
  @Input() imgHeight: string = 'auto';
}
